import FlashService from '~/services/flash/FlashService'

export default ({ $dep }: any) => {
  const flashService = $dep(FlashService)
  flashService.clearBackendCookie()
}
